import { Ajax } from "../Common/Ajax";
import { GlobalData } from "../Common/GlobalData";
import { Notification, TemplateHelpers } from "../Common/KendoHelpers";

export class WatchList {
    private readonly GRID = '#grid';

    private gridDataSourceOptions!: kendo.data.DataSourceOptions;

    private static _instance: WatchList;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.init();
    }

    private init() {
        this.gridDataSourceOptions = {
            transport: {
                read: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST,
                create: {
                    url: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST,
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                },
                update: {
                    url: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST,
                    type: 'PUT',
                    contentType: 'application/json',
                    dataType: 'json',
                },

                parameterMap: function (options: any, operation: any) {
                    if (operation !== "read" && options.models) {
                        return kendo.stringify(options.models);
                    }
                }
            },
            batch: true,
            serverPaging: false,
            serverSorting: false,
            schema: {
                model: {
                    id: "symbol",
                    fields: {
                        symbol: { type: "string"/*, editable: false*/, nullable: false },
                        pattern: {
                            type: "string",
                            validation: {
                                custom: function (input: any) {
                                    // Workaround to deal with the fact that the autocomplete
                                    // sets the value to "[Object object]" after the first edit.
                                    const grid = $('#grid').data("kendoGrid")!;
                                    const row = input.closest("tr");
                                    const dataItem = grid.dataItem(row) as any;
                                    dataItem.pattern = input["0"].value;

                                    return true;
                                }
                            }
                        },
                        action: { type: "string" },
                        analysis: { type: "string" },
                    }
                }
            }
        };

        $(this.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(this.gridDataSourceOptions),
            dataBound: () => {
                this.defineDeleteButtonEvents();
            },
            height: 915,
            editable: true,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            toolbar: [
                { name: "create" },
                { name: "save" },
                { name: "cancel" },
            ],
            saveChanges: function (e) {
                const self = WatchList.getInstance();

                const rows = ($(self.GRID).data("kendoGrid") as any)._data;
                const invalidRows = [];

                // Check all of the global validation rules.
                for (let i = 0; i < rows.length; ++i) {
                    rows[i].validationErrorMessage = '';
                    if (rows[i].dirty) {
                        // All records must have a non-empty symbol.
                        if (!rows[i].symbol) {
                            rows[i].validationErrorMessage += 'Symbol on row ' + i + ' cannot be empty.';
                            invalidRows.push(rows[i]);
                        }
                    }
                }

                // If there were any invalid rows, prevent the update and display the error messages.
                if (invalidRows.length > 0) {
                    // Don't call the server with the update.
                    e.preventDefault();

                    // Display all of the error messages.
                    let globalValidationErrorMessages = '';
                    for (let i = 0; i < invalidRows.length; ++i) {
                        globalValidationErrorMessages += invalidRows[i].validationErrorMessage;
                    }
                    $('#globalValidationErrorMessages').html(globalValidationErrorMessages);
                }
                else {
                    $('#globalValidationErrorMessages').html('');
                }
            },
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '10%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "action",
                    title: "Action",
                    width: "45%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "analysis",
                    title: "Analysis",
                    width: "45%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    width: '4%',
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getDeleteButtonTemplate('../images', 'symbol')),
                }
            ]
        });
    }

    private defineDeleteButtonEvents() {
        const deleteButtonClass = TemplateHelpers.getDeleteButtonClass();
        $('.' + deleteButtonClass).off('click').on('click', (event) => {
            const symbol = event.currentTarget.id.slice(deleteButtonClass.length);

            kendo.confirm('Are you sure that you want to delete ' + symbol + '?')
                .then(() => {
                    this.deleteRow(symbol);
                });
        });
    }

    private deleteRow(symbol: string) {
        const success = () => {
            const grid = $(this.GRID).data('kendoGrid')!;
            grid.setDataSource(new kendo.data.DataSource(this.gridDataSourceOptions));
        };

        const error = () => {
            const msg = new Notification();
            msg.error(symbol + ' could not be deleted');
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST +
            '?symbol=' + symbol, 'DELETE', null, success, error);
    }
}
